import apolloClient from "../apolloClient";
import {
	CREATE_SUBSCRIPTION,
	GET_SUBSCRIPTIONS,
	GET_WINE_CLUB_SUBSCRIPTIONS,
} from "./graphql";
import { mapModelToSubscription } from "./helper";

class SubscriptionService {
	async create(model, customerId) {
		await apolloClient.mutate({
			mutation: CREATE_SUBSCRIPTION,
			variables: {
				subscription: mapModelToSubscription(model, customerId),
			},
		});
	}

	async getSubscriptions() {
		const { data } = await apolloClient.query({
			query: GET_SUBSCRIPTIONS,
		});

		return data.mySubscriptions.nodes;
	}
	async getWineClubSubscriptions() {
		const { data } = await apolloClient.query({
			query: GET_WINE_CLUB_SUBSCRIPTIONS,
		});

		return data.mySubscriptions.nodes;
	}
}

export default new SubscriptionService();
